import { compactChatbotInfoFields, type ChatbotInfoField } from '@workspace/types';

export function infoFieldsFormToPayload(data: {
  botInfoFieldsEnabled?: boolean;
  userInfoFieldsEnabled?: boolean;
  infoFields?: ChatbotInfoField[];
}): {
  botInfoFieldsEnabled: boolean;
  userInfoFieldsEnabled: boolean;
  infoFields: ChatbotInfoField[];
} {
  return {
    botInfoFieldsEnabled: Boolean(data.botInfoFieldsEnabled),
    userInfoFieldsEnabled: Boolean(data.userInfoFieldsEnabled),
    infoFields: compactChatbotInfoFields(data.infoFields),
  };
}
